import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const privacyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPrivacy: builder.query({
      query: () => {
        return `/organisation/privacy`
      },
      providesTags: (result = [], error, arg) => [{ type: 'Privacy' }],
    }),
    updatePrivacy: builder.mutation({
      query: (privacy) => ({
        url: `/organisation/privacy`,
        method: 'PUT',
        body: privacy,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Privacy' }
      ]
    })
  }),
  overrideExisting: false
})

export const {
  useGetPrivacyQuery,
  useUpdatePrivacyMutation
} = privacyApiSlice
